import NavbarReducer from './containers/Navbar/reducer.js';
import ScrollSpyReducer from './components/ScrollSpy/reducer.js';
import ModalsReducer from '../shared/components/Modals/reducer.js';
import CurrentUserReducer from './components/CurrentUserLoader/reducer.js';
import BlogReducer from './components/Blog/reducer.js';
import SecteursReducer from './components/Secteurs/reducer.js';
import SearchReducer from './containers/Search/reducer.js';
import UniverseReducer from './components/UniverseLoader/reducer.js';
import ErrorReducer from './containers/Errors/reducer.js';

import {reducer as toastrReducer} from 'react-redux-toastr'
import {reducer as formReducer} from 'redux-form';

export default {
  form: formReducer,
  navbar: NavbarReducer,
  scrollSpy: ScrollSpyReducer,
  modals: ModalsReducer,
  search: SearchReducer,
  currentUser: CurrentUserReducer,
  blog: BlogReducer,
  secteurs: SecteursReducer,
  universe: UniverseReducer,
  toastr: toastrReducer,
  errors: ErrorReducer,
};